import { VolumeOff, VolumeUp } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useContent } from 'contexts/Content/Content';
import { useSounds } from 'contexts/Sounds/Sounds';
import { Fullscreen } from '@mui/icons-material';

export default function HeaderControls({ fullScreenHandle }: FullscreenButtonProps) {
    const content = useContent();
    const sounds = useSounds();

    const color = content.header.foreground || '#FAAD19';

    return (
        <>
            <Box color={sounds.muted ? '#AEAEAE' : color}>
                <IconButton
                    aria-label={sounds.muted ? 'unmute' : 'mute'}
                    color="inherit"
                    onClick={() => sounds.setMuted(!sounds.muted)}
                >
                    {sounds.muted ? <VolumeOff /> : <VolumeUp />}
                </IconButton>
            </Box>
            <Box color={content.header.foreground || '#FAAD19'}>
                <IconButton aria-label="enter fullscreen" color="inherit" onClick={fullScreenHandle.enter}>
                    <Fullscreen />
                </IconButton>
            </Box>
        </>
    );
}
